// extracted by mini-css-extract-plugin
module.exports = {"wrap":"App_wrap_2esTH","main":"App_main_2xcRE","content":"App_content_pIJBB","hasHeader":"App_hasHeader_UB1DN"};